<template>
    <div>
        <!-- Featured Premium -->
        <div v-if="featuredClass !== null && isPremium">
            <b-row class="mt-3 premium-row">
                <b-col cols="12">
                    <div>
                        <b-badge pill class="badge-orange">New Premium Course</b-badge> <b-badge pill class="ml-2 badge-blue">{{ featuredClass.credits }} CE Credits</b-badge>
                    </div>
                    <div class="premium-class-title mt-2 mb-2" pointer @click.prevent="gotoPremiumClass(featuredClass.slug)">{{ featuredClass.className }}</div>
                    <div class="premium-speaker mb-2">{{ featuredClass.name }}</div>
                    <div class="text-white">
                        {{ featuredClass.blurb }}
                    </div>
                    <div class="mt-2 mb-3 text-center" style="line-height: 250%;">
                        <b-badge pill class="ml-2 badge-blue">{{ featuredClass.numLessons }}</b-badge> <span class="text-white">Modules</span>
                        &nbsp;&nbsp;
                        <b-badge pill class="ml-2 badge-blue">{{ featuredClass.durationHours }}</b-badge> <span class="text-white">Watch Time (hours)</span>
                    </div>

                    <!-- Teaser -->
                    <b-embed v-if="showVideo" ref="plyr"
                    type="iframe"
                    aspect="16by9"
                    :src="getVideoUrl(featuredClass.youtubeUrl)"
                    allowfullscreen
                    ></b-embed>

                    <div class="font-weight-bold text-center mt-2 text-white">
                        Watch Trailer <b-icon icon="play-circle-fill"></b-icon>
                    </div>

                    <b-badge pill variant="danger">{{ featuredClass.priceDiscountStr }}</b-badge>
                    <!-- <span class="span-discount"></span> -->
                    <span class="span-price">&nbsp;&nbsp;${{ featuredClass.price }}</span>
                    <span class="span-price-list custom-opacity">&nbsp;&nbsp;&nbsp;Reg. price:&nbsp;<span class="diagonal-strike">${{ featuredClass.priceList }}</span></span>

                    <div class="mt-3 mb-2">
                        <b-button @click.prevent="gotoClassSSO(featuredClass.learnworldsClassId)" variant="danger" block size="lg" class="rounded button-start">Start Course</b-button>
                    </div>
                </b-col>
            </b-row>
        </div>

        <!-- Featured Class -->
        <div v-if="featuredClass !== null && !isPremium">
            <b-row class="mt-2 mb-2 pointer" @click="gotoFeaturedClass()">
                <b-col cols="4" class="text-center">
                    <b-img fluid v-bind:src="featuredClass.photo" />
                    <div class="text-center completed">FEATURED</div>
                </b-col>
                <b-col cols="8" style="margin-left: -20px;">
                    <div class="class-title">{{featuredClass.className}}</div>
                    <div class="class-details">
                    {{featuredClass.name}}
                    <br>Sponsor: {{featuredClass.companyName}}
                    <br><!-- {{featuredClass.releaseDateUTC | prettyDate}} - -->{{featuredClass.credits}} CEU (Self-Study)
                    </div>
                    <div class="mt-2" v-if="false">
                    <b-button :to="{ path: '/classroom/'+featuredClass.hash }">Enter Classroom</b-button>
                    </div>
                </b-col>
                <b-col cols="12">
                    <div class="mt-2 class-details" style="width:95%;">{{featuredClass.blurb}}</div>
                </b-col>
            </b-row>
        </div>

        <!-- Featured Podcast -->
        <div v-if="featuredPodcast !== null">
            <b-row class="mt-2 mb-2 pointer" @click="gotoFeaturedPodcast()">
                <b-col cols="4" class="text-center">
                    <b-img fluid v-bind:src="featuredPodcast.photo" />
                    <div class="text-center completed">FEATURED</div>
                </b-col>
                <b-col cols="8" style="margin-left: -20px;">
                    <div class="class-title">{{featuredPodcast.title}}</div>
                    <div class="class-details">
                        {{featuredPodcast.speakerName}}
                        <br>Sponsor: {{featuredPodcast.companyName}}
                        <br v-if="featuredPodcast.credits > 0"><!-- {{featuredPodcast.releaseDateUTC | prettyDate}} - --><span v-if="featuredPodcast.credits > 0">{{featuredPodcast.credits}} CEU (Self Study)</span>
                        <br><b-icon icon="clock"></b-icon>&nbsp;{{featuredPodcast.durationSec | prettySeconds}}
                    </div>
                </b-col>
            </b-row>
        </div>

        <!-- Featured Blog Post -->
        <div v-if="featuredBlog !== null">
            <b-row class="mt-2 mb-2 pointer" @click="gotoFeaturedBlogPost()">
                <b-col cols="12">
                  <div class="class-title">
                    <b-icon icon="caret-right-fill"></b-icon> <span v-if="featuredBlog.featured" class="txt-blog-featured">Featured</span>{{ featuredBlog.title }}
                  </div>
                  <div class="class-details">
                    {{ featuredBlog.blurb }}
                  </div>
                </b-col>
            </b-row>
        </div>

    </div>
</template>

<script>
/* eslint-disable */

'use strict'

import service from "@/service/service"
import utils from "@/utils/utils"
import constants from "@/config/constants"

export default {
    name: "VpFeaturedContent",
    data() {
        return {
            debug: false,
            error: false,
            errorMsg: '',
            busy: true,
            submitted: false,
            studentHash: this.$root.getToken(),
            featuredClass: null,
            featuredPodcast: null,
            featuredBlog: null,
            featuredHash: null,
            showVideo: true
        }
    },
    props: {
        fc: {   // featured class
            type: Object,
            default: null
        },
        fp: {   // featured podcast
            type: Object,
            default: null
        },
        fb: {   // featured blog
            type: Object,
            default: null
        },
        fh: {   // VpAdFeaturedContent.hash
            type: String,
            default: null
        }
    },
    computed: {
        isPremium() {
            return this.featuredClass.typeId == constants.CLASS_TYPE.PREMIUM
        }
    },
    methods: {
        gotoClass(hash) {
            this.$router.push(`/classroom/${hash}`)
        },
        gotoPodcast(ps,p) {  // podcastShowHash, podcastHash
            this.$router.push(`/podcast/${ps}/${p}`)
        },
        gotoBlogPost(blogId) {
            this.$router.push(`/blog-post/${blogId}`)
        },
        gotoClassSSO(learnworldsClassId) {
            if (this.debug) console.log(`SSO Login: ${learnworldsClassId}`)

            service.getClassSSO(learnworldsClassId, this.studentHash)
            .then(
                ( data => {
                    if (this.debug) console.log('gotoClassSSO', data)
                    if (data.status) {
                        // this.lwToken = data.lwToken
                        this.lwUrl = data.lwUrl
                        // this.classObj = data.classObj
                        // this.studentData = data.studentData
                    }

                }).bind(this)
            )
            .finally ( e => {
                this.loading = false
                if (this.debug) console.log(`gotoClassSSO lwUrl: ${this.lwUrl}` )
                if (this.debug && !window.confirm('Proceed to LearnWorlds?')) {
                return  // debugging - bail out
                }
                window.location.href = this.lwUrl   // SSO Login to LW site
            })

        },
        gotoPremiumClass(hash) {
            this.$router.push(`${constants.PATHS.PREMIUM_BASE}/${hash}`)
        },
        hasVideo(youtubeUrl) {
            let aout = youtubeUrl != null
            return aout
        },
        getVideoUrl(youtubeUrl) {
            let code = utils.getYoutubeCode(youtubeUrl)
            let url = utils.getYoutubeUrl(code, true)
            return url
            // return 'https://www.youtube.com/embed/zpOULjyy-n8?rel=0'  // reo
            // return 'https://www.youtube.com/embed/pTvxZgiuU3Y?rel=0'
            // return 'https://www.youtube.com/watch?v=pTvxZgiuU3Y&rel=0'  // viva
        },
        gotoFeaturedClass() {
            this.busy = true
            service
                .logFeaturedContentClick(this.studentHash, constants.VPAD_SLOT_TYPE.VPAD_FEATURED_CLASS, this.featuredHash)
                .then(res => {
                    if (this.debug) console.log(res);
                    if (!res.status) {
                        console.log('Error Class! logFeaturedContentClick()')
                    }
                })
                .finally(() => {
                    this.busy = false
                    this.gotoClass(this.featuredClass.hash)
                })
                .catch(e => console.log(e))
        },
        gotoFeaturedPodcast() {  // podcastShowHash, podcastHash
            this.busy = true
            service
                .logFeaturedContentClick(this.studentHash, constants.VPAD_SLOT_TYPE.VPAD_FEATURED_PODCAST, this.featuredHash)
                .then(res => {
                    if (this.debug) console.log(res);
                    if (!res.status) {
                        console.log('Error Podcast! logFeaturedContentClick()')
                    }
                })
                .finally(() => {
                    this.busy = false
                    this.gotoPodcast(this.featuredPodcast.podcastShowHash, this.featuredPodcast.hash)
                })
                .catch(e => console.log(e))
        },
        gotoFeaturedBlogPost() {
            this.busy = true
            service
                .logFeaturedContentClick(this.studentHash, constants.VPAD_SLOT_TYPE.VPAD_FEATURED_BLOG, this.featuredHash)
                .then(res => {
                    if (this.debug) console.log(res);
                    if (!res.status) {
                        console.log('Error Blog! logFeaturedContentClick()')
                    }
                })
                .finally(() => {
                    this.busy = false
                    this.gotoBlogPost(this.featuredBlog.id)
                })
                .catch(e => console.log(e))
        },
    },
    created() {
        // console.log(this.mb)
        this.featuredClass = this.fc || null
        this.featuredPodcast = this.fp || null
        this.featuredBlog = this.fb || null
        this.featuredHash = this.fh || null
        if (this.debug) console.log(`vpfeaturedcontent  hash: ${this.featuredHash}`)
    },
    mounted() {
        // console.log('vpfeaturedcontent mounted')
    },
    beforeDestroy() {
        // console.log('vpfeaturedcontent beforeDestroy')
    }
}
</script>


<style scoped>

/*
Orange   #FF9159
Blue (darker) Title    #2B5AA0
Blue (lighter) pill button  #4A90E2
 */

.premium-row {
  border: 2px solid #2B5AA0; /* dark blue */
  border-radius: 12px;        /* Rounded corners */
  padding: .5rem;              /* Optional spacing */
  background-color: #2B5AA0;     /* dark blue */
  /* margin-left: .5rem; */
  /* width: 95%; */
  margin: -.2rem -.1rem 2rem -.6rem !important;
}

.corner-label {
  position: absolute;
  top: -0.5rem;
  right: -0.5rem;
  padding: auto 3.0rem auto 3.0rem !important;
}

.badge-orange {
  background-color: #FF9159;
  color: white;
}

.badge-blue {
  background-color: #4A90E2;
  color: white;
}

.premium-class-title {
   color: #FFFFFF;
   font-size: 1.2rem;
   font-weight: bold;
   /* margin: .5rem auto .5rem auto; */
}

.premium-speaker {
   color: #FFFFFF;
   font-size: 1rem;
   font-weight: bold;
}

.badge-limited {
    font-size: 1.1rem;
    padding: .5rem;
}

.span-discount {
    color: #FF9159;
    font-size: 1.8rem;
    font-weight: bold;
}

.span-price {
    color: #FFFFFF;
    font-size: 1.8rem;
    font-weight: bold;
}

.span-price-list {
    color: #FFFFFF;
    /* font-size: 2rem; */
    font-weight: bold;
}

.diagonal-strike {
  position: relative;
  display: inline-block;
}

.diagonal-strike::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 1px;
  background: #000; /* or any color */
  transform: rotate(-20deg);
  transform-origin: center;
}

.custom-opacity {
  opacity: .7;
}

.button-start {
  background-color: #FF9159;
  border-color: #FF9159;
  color: white;
}

.button-overview {
  background-color: #FFF;
  border-color: #2B5AA0;
  color: #2B5AA0;
  padding: .5rem;
  font-size: 1.25rem;
  font-weight: 400;
}

.thick-outline {
  border-width: 3px !important; /* Increase outline thickness */
}
</style>




// WEBPACK FOOTER //
// src/components/VpFeaturedContent.vue